import { BankAccountSource } from '@features/bankAccounts/enums/bankAccountSource'
import { BankAccount } from '@features/bankAccounts/types/bankAccount'
import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'
import { Account } from '@modules-deprecated/app/accounts/types'

interface FindWidgetBankConnectionProps {
  openBankingAccounts?: OpenBankingAccount[]
  bankAccounts?: BankAccount[]
  selectedBankAccountId?: string
  connectedBookkeepingAccounts?: Account[]
}

export const findWidgetBankConnection = ({
  openBankingAccounts,
  bankAccounts,
  selectedBankAccountId,
  connectedBookkeepingAccounts,
}: FindWidgetBankConnectionProps): OpenBankingAccount | BankAccount | undefined => {
  const openBankingAccountsWithActiveAccounts = openBankingAccounts?.filter((openBankingAccount) => {
    return connectedBookkeepingAccounts?.some((account) => account.id === openBankingAccount.externalAccountId)
  })

  if (selectedBankAccountId) {
    const selectedOpenBankingAccount = openBankingAccountsWithActiveAccounts?.find(
      (openBankingAccount) => openBankingAccount?.externalAccountId === selectedBankAccountId,
    )
    if (selectedOpenBankingAccount) {
      return selectedOpenBankingAccount
    }

    const selectedBankAccount = bankAccounts?.find(
      (bankAccount) => bankAccount.bookkeepingAccountId === selectedBankAccountId,
    )
    if (selectedBankAccount) {
      return selectedBankAccount
    }
  }

  const firstOpenBankingAccount = openBankingAccountsWithActiveAccounts?.[0]

  if (firstOpenBankingAccount) {
    return firstOpenBankingAccount
  }

  const firstBankAccount = bankAccounts?.find((bankAccount) => bankAccount.source === BankAccountSource.SHINE_BANKING)
  return firstBankAccount
}
